import r from "./ghl-ui.es1309.js";
var e = r("toUpperCase");
const p = e;
export {
  p as default
};
